import type React from 'react';

import { Text } from '@change/ds-core-ui';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { Translate } from '@change-corgi/core/react/i18n';

export const ListHeading: React.FC<{ title: TranslationKey }> = ({ title }) => {
	return (
		<Text variant="heading" as="h2" size="small" className="text-typography-strong mt-0 mb-6 pb-0">
			<Translate value={title} />
		</Text>
	);
};
